<!--
  File name: Pie.vue
  Program Description:
    - This component displays the pie chart from vue-chart-js reusable components.
    - It renders the pie chart according to the passed chart data.
-->
<script>
import { Pie, mixins } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import * as outlabels from 'chartjs-plugin-piechart-outlabels'
const { reactiveProp } = mixins

export default {
  extends: Pie,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    canvasHeight: {
      type: String,
      default: '750px'
    }
  },
  mounted () {
    this.$refs.canvas.setAttribute('height', this.canvasHeight)
    this.addPlugin(outlabels)
    this.addPlugin(ChartDataLabels)
    this.renderChart(this.chartData, this.options)
  }
}
</script>
